(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["press-archive"] && !Shopify.designMode) return;
  try {
    
function initialiseCavagaPress(root){
  if(root.dataset.pressBound)return;
  root.dataset.pressBound='true';
  const dialog=root.querySelector('dialog');
  const image=dialog.querySelector('[data-press-image]');
  const title=dialog.querySelector('h2');
  const external=dialog.querySelector('[data-press-open-tab]');
  let opener;
  root.querySelectorAll('[data-press-document]').forEach(link=>{
    link.addEventListener('click',event=>{
      if(event.metaKey||event.ctrlKey||event.shiftKey||event.altKey||typeof dialog.showModal!=='function'||!link.dataset.documentImage)return;
      event.preventDefault();opener=link;
      title.textContent=link.dataset.documentTitle;
      image.alt=link.dataset.documentTitle;
      image.src=link.dataset.documentImage;external.href=link.href;
      dialog.showModal();
    });
  });
  dialog.querySelector('[data-press-close]').addEventListener('click',()=>dialog.close());
  dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});
  dialog.addEventListener('close',()=>{image.removeAttribute('src');if(opener)opener.focus();});
}
document.querySelectorAll('.cavaga-press').forEach(initialiseCavagaPress);
document.addEventListener('shopify:section:load',event=>{event.target.querySelectorAll('.cavaga-press').forEach(initialiseCavagaPress);});

  } catch(e) { console.error(e); }
})();
})();
